import "./GetClarity.module.css";
import Header from "@/reusable_sections/Header";
import BeginYourConsultation from "./sections/BeginYourConsultation";
import OurPresenceInIndia from "./sections/OurPresenceInIndia";
import Footer from "@/reusable_sections/Footer";
export default function GetClarityPage() {
  return <div>
      <Header />
      <BeginYourConsultation />
      <OurPresenceInIndia />
      <Footer />
    </div>;
}